import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    title: PropTypes.string,
    secondaryTitle:  PropTypes.string,
    index: PropTypes.number,
    active: PropTypes.bool,
    completed: PropTypes.bool,
    first: PropTypes.bool,
    isLast: PropTypes.bool,
    href: PropTypes.string,
    onClick: PropTypes.func,
};


export default class Step extends React.Component{
    constructor(props){
        super(props);

    }

    render() {
        const{title, secondaryTitle, index, active, completed, first, isLast, href, onClick} = this.props;

        const circleText = index + 1;

        let circleClasses = '';
        let barClasses = '';
        if(this.props.active) {
           circleClasses = 'circle-active';
           barClasses = 'bar-active';
        }
        if(this.props.completed) {
            circleClasses = 'circle-completed';
            barClasses = 'bar-completed';
        }



        return(
            <div className='step--style'>
                <div className={`circle--style ${circleClasses}`}>
                    {active || completed ?
                        <a href={href} onClick={onClick} className='index--style'>{circleText} </a> :
                        <span className='index--style'>{circleText}</span>
                    }
                </div>
                {!first && <div className={`leftBar ${barClasses}`}> </div> }
                {!isLast && <div className={`rightBar ${barClasses}`}> </div> }
                <div className='main-title-text'> {title} </div>
                <div className='secondary-title-text'>{secondaryTitle}</div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/StepperHorizontal/Step.js